module.exports = __webpack_public_path__ + "static/media/1_2.4f0bd2c6.png";